import React, {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {ProfileKey} from '@findhotel/sapi/dist/types/packages/core/src'
import {Home} from 'components/Home'
import TrackPageView from 'components/TrackPageView'
import {useSyncHomePageSearchBox} from 'hooks/useSyncHomePageSearchBox'
import {useSyncStoreWithUrl} from 'hooks/useSyncStoreWithUrl'
import {getSapiMetaOptions} from 'modules/meta/selectors'
import {SapiProvider} from 'modules/sapiSearch/SapiProvider'

import InjectPageDataId from '@vio/core/src/analytics/components/InjectPageDataId'
import {Page} from '@vio/core/src/analytics/types/Events'
import {getDataFile} from '@vio/core/src/experiments/modules/selectors'
import {collectSapiVariationsParam} from '@vio/core/src/experiments/sapi'

const HomeView = () => {
  useSyncStoreWithUrl()
  useSyncHomePageSearchBox()
  const sapiMetaOptions = useSelector(getSapiMetaOptions)
  const dataFile = useSelector(getDataFile)
  const variations = collectSapiVariationsParam(
    dataFile?.featureFlags.map(({key}) => key)
  )
  const generateOptions = useCallback(
    () => ({
      ...sapiMetaOptions,
      variations
    }),
    [sapiMetaOptions]
  )

  return (
    <>
      <TrackPageView pageName={Page.Home} />
      <InjectPageDataId page={Page.Home} />

      <SapiProvider
        profileKey={process.env.NEXT_PUBLIC_SAPI_PROFILE_KEY as ProfileKey}
        generateOptions={generateOptions}
      >
        <Home />
      </SapiProvider>
    </>
  )
}

export default HomeView
